import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import BarCounter from '../BarCounter';

import styles from './Hero.module.scss';

const Hero = ({page}) => (
  <section className={styles.container}>
    {!page.acf.heroBgColor && page.thumbnail.fluid
      ? (
        <Img
          className={styles.background}
          critical={true}
          fluid={page.thumbnail.fluid}
          style={{position: false}}
        />
      )
      : null}
    <div
      className={styles.overlay}
      style={page.acf.heroBgColor ? {backgroundColor: page.acf.heroBgColor} : null}
    >
      <div className="wrap">
        <div className={styles.text}>
          <div className={styles.counters}>
            {page.acf.heroLogo
              ? <h2><img className={styles.logo} alt={page.title} src={`https://cdn.samiabomfim.com.br${page.acf.heroLogo.source_url}`} /></h2>
              : <h2 className={styles.title}>{page.title}</h2>
            }
            <BarCounter channelId={page.acf.channelId} />
          </div>
        </div>
      </div>
    </div>
  </section>
);

Hero.propTypes = {
  page: PropTypes.object,
};

export default Hero;
